import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

let nav = document.querySelector('.page-marques__nav')

if(nav){
  if(window.innerWidth > 680){
    let pin_tab = gsap.timeline({
      scrollTrigger: {
        trigger: nav,
        endTrigger: document.querySelector('.page-marques__content-outer'),
        pin: true,
        pinSpacing: false,
        start: "top top+=60",
        end: `bottom top+=${nav.scrollHeight + 60}`
      }
    })
  }
  
  document.querySelectorAll('.scroll-to').forEach(button => {
    let target = button.dataset.target
    button.addEventListener('click', (e)=>{
      gsap.to(window, {duration: 1, scrollTo: {y: target, offsetY: 60}})
    })
  })
  
}